
<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  props: {

  },
  components: {

  },
  methods: {
    
  },
  mounted () {
    /*if ( !this.$route.params.session_id ) {
      // generate a new session_id
      console.log('TODO: generate new session_id from backend')

      // random 10 char string 0-9a-z (base 36)
      //let random_session_id = Math.random().toString(36).substring(2, 12);
      //this.$store.commit('initSession',random_session_id);
      // get uuid from backend
      // let context = this;
      this.$store.dispatch('getUUID')
        .then(response => {
          console.log(response);
          //this.$router.push( { name: 'Vehicle.Plate', params: { session_id: this.$store.state.session_id } } );
        }, error => {
          console.log('error',error);
          if( error === 'login_required' ){
            window.location = "/app/login";
          } else {
            // Need to show a generic error, and somehow report the real error back to the site-owners to understand why
          }
          // context.errors = error;
        })
      return false;
    }*/
  },
  data () {
    return {
    }
  }
}

</script>

<style scoped lang="scss">
  
</style>